export default {
  name: 'CreateRiskFramework',
  data() {
    return {
      hero: {
        title: 'Risk Management Hub',
        description: 'Manage Risk Framework Assessments',
      },
      frameworks: [
        {
          id: 1,
          frameworkId: 'FR-001',
          type: 'Operational',
          title: 'Exposure Assessment',
          description: 'Evaluation of third-party surface exposure and control coverage.',
          status: 'Active',
        },
        {
          id: 2,
          frameworkId: 'FR-002',
          type: 'Strategic',
          title: 'Market Volatility',
          description: 'Macroeconomic impact analysis on long-term business resilience.',
          status: 'Active',
        },
      ],
    };
  },
  methods: {
    format_framework_id(value) {
      return String(value || '').trim();
    },
  },
};
